import React, { FC } from 'react'
import GlobalHeaderLogo from '../topHeader/GlobalHeaderLogo'
import styles from './DefaultHeader.module.scss'
import { Link } from 'react-router-dom'
import { NATIVE_APP_HELPER } from 'constants/native_app_helper.constants'

export const NativeDefaultHeader: FC = () => {
  return (
    <div
      className={styles.DefaultHeader}
      data-testid="navigation-menu-container"
      style={
        NATIVE_APP_HELPER.GET_PLATFORM === 'ios'
          ? { paddingTop: '80px', paddingBottom: '25px' }
          : undefined
      }
    >
      <div className={styles.TopHeaderLogo}>
        <Link to="/calendar">
          <GlobalHeaderLogo data-testid="top-header-logo" />
        </Link>
      </div>
    </div>
  )
}
